module.exports = __webpack_public_path__ + "img/box-digital.84ce24dc.svg";